<template>
    <div class="col-12" style="margin-bottom: 4pt;">
        <div class="row">
            <label class="label col-md-5 col-sm-12">{{ label }}</label>
            <span 
                style="gap: 2pt;" 
                class="d-flex flex-wrap align-items-start col-md-7 col-sm-12" 
                v-if="$slots.default">
                <slot></slot>
            </span>
            <span v-else class="col-md-7 col-sm-12">{{ value }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props : { 
        value: {
            type: [String, Number],
            default: '',
        }, 
        label: String,
        layout: {
            type: String,
            default: 'inline'
        }
    }
}
</script>